import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers/index";

const middleware = [thunk];

// Redux Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["loginUser"], // Only persist loginUser state
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let devTools;
if (process.env.NODE_ENV === "development") {
  devTools = composeWithDevTools(applyMiddleware(...middleware));
} else {
  devTools = applyMiddleware(...middleware);
}

const store = createStore(persistedReducer, {}, devTools);
const persistor = persistStore(store);

export { store, persistor };
